<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="38" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="游戏">
          <ThrottleSelector
            v-model="labelId"
            :list="gameData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label-width="0" class="bg-transparent">
          <div class="operate-btns">
            <ElButton type="primary" @click="$emit('on-add')">新增回款计算器</ElButton>
            <ElButton @click="$emit('on-down')">模版下载</ElButton>
            <Upload action="" :before-upload="preUpload" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton style="margin-left: 10px">导入回款计算器</ElButton>
            </Upload>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'TagsFilter',
  components: { ThrottleSelector },
  props: {
    gameData: {
      type: Array
    }
  },
  data() {
    return {
      labelId: ''
    }
  },
  methods: {
    sendEvent() {
      this.$emit('on-change', { mGameId: this.labelId === '' ? undefined : this.labelId })
    },
    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './styles/table-filters.scss';
</style>
